var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"splashscreenheader"},[_c('router-link',{staticClass:"splashscreenheader__link",attrs:{"to":"/","aria-label":"Link to Homepage"}},[_c('dmp-logo',{staticClass:"splashscreenheader__logo"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }